import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  inject,
  AfterViewInit,
  ViewChild,
  TemplateRef,
  Input, OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent,
  WmsDialogBodyComponent, WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent, WmsMessageComponent
} from "@wms/components";
import {PageTemplateComponent} from "@wms/app/components/page-template/page-template.component";
import {PageLayoutsService} from "@wms/page-workspace";
import {
  DialogService,
  I18nService, NotificationService,
  PageService,
  PageTemplatesService,
  ProjectService,
  TypeFactoryService
} from "@wms/services";
import {processLiveWidgetTemplate, stringStartsWith, StudioUtils} from "@wms/core";
import {remove, capitalize, each, forEach, isArray, isString, words, uniq} from "lodash-es";
import {BaseVariableService} from "@wms/variables";
import {PageWorkspaceComponent, PageWsService} from "@wms/workspace";
import {AppRef} from "@wms/design-container";
import {runtimeEventManager} from "@wm/core";
import {EventManagerService} from "@wms/app";





let externalTypes:any[] = [];
const ACTIONS         = {
  'ADD'   : 1,
  'DELETE': 2
};

@Component({
  selector: 'wms-add-new-page',
  standalone: true,
  imports: [CommonModule, WmsDialogHeaderComponent, WmsDialogFooterComponent, WmsDialogBodyComponent, PageTemplateComponent, WmsMessageComponent, WmsDialogComponent],
  templateUrl: './wms-add-new-page.component.html',
  styleUrls: ['./wms-add-new-page.component.less']
})
export class WmsAddNewPageComponent  extends  BaseComponent implements OnInit, OnDestroy{
  @Input() context: any;
  @Output() handleClose = new EventEmitter<any>();
  @Output() newPage: any
  @Output() isPrefabType: boolean
  @Output() template: any;
  @Output() newPageTypes: any
  @Output() selectedWidget: any
  @Output() templateData: any
  @Output() showTemplatePreview: boolean;
  @Output() stepCounter = 0;
  @Output() isTemplateBundleType: any
  @Output() tempCategory: any
  @Output() templatePlatformType = 'WEB'
  @Output() selectedOrganization: any;
  @Output() loadingTemplates: boolean;
  @Output() templateType: string;
  @Output() isWeb: boolean;
  @Output() isMobile: boolean;
  @Output() activeTemplate: any;
  @Output() allTemplates: any
  @Output() ctrlScope: any
  @Output() fileAddMessage: any = ''
  @Output() templateWidgets: any
  @Output() preDefinedTemplateSelected: any
  @Output() fields: any;
  @Output() baseScreen: string;
  @Output() createdVariable: any = {};
  @Output() pageLayout: any;
  @Output() listImage: string
  isMobileApplicationType: boolean;
  listTemplates: any = [];
  PageLayoutsService: any
  datatypes: any;
  layouts: any;
  templateCreated: boolean;
  propertyName:any;
  variableService: BaseVariableService;
  pageService: PageService;
  appRef: AppRef;
  pageWs: PageWorkspaceComponent;
  pageWsService:PageWsService;
  eventmanager:EventManagerService;
  notificationService:NotificationService;
  activePageName:any
  service: string;
  selectedDataSource: any;
  @Output() preDefinedTemplates: any = {
    "Details_List": {
      "backgroundPosition": "-53px -14285px",
      "template": '<wm-container class="media-left">' +
        '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
        '</wm-container>' +
        '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
        '<wm-label name="Name" data-is-target class="p media-heading" caption="{}" fontsize="1.143" fontunit="em"></wm-label>' +
        '<wm-label name="JobTitle" data-is-target caption="{}" class="p text-muted"></wm-label>' +
        '</wm-container>'
    },
    "Contact_List": {
      "backgroundPosition": "-53px -15066px",
      "template": '<wm-container class="media-left">' +
        '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
        '</wm-container>' +
        '<wm-container class="media-body">' +
        '<wm-label class="p media-heading" name="Name" data-is-target caption="{}" fontunit="em" padding="unset unset unset 1.25em"></wm-label>' +
        '</wm-container>'
    },
    "Email_List": {
      "backgroundPosition": "-53px -14683px",
      "template": '<wm-container name="pictureContainer" class="media-left">' +
        '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
        '</wm-container>' +
        '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
        '<wm-label name="Name" data-is-target class="media-heading pull-left" caption="{}" fontunit="em"></wm-label>' +
        '<wm-label name="Time" data-is-target caption="{}" class="pull-right" margin="0px unset unset unset"></wm-label>' +
        '<wm-label caption="{}" data-is-target class="h5" margin="0px unset unset unset" name="JobTitle"></wm-label>' +
        '<wm-label name="Content" data-is-target caption="{}" class="p text-muted"></wm-label>' +
        '</wm-container>'
    },
    "Media_List": {
      "backgroundPosition": "-53px -15443px",
      "template": '<wm-container class="media-left media-top">' +
        '<wm-picture name="Picture" data-is-target class="media-object" width="32pt" height="32pt" picturesource="{}"></wm-picture>' +
        '</wm-container>' +
        '<wm-container class="media-body" padding="unset 1.5em unset 1.25em">' +
        '<wm-label class="pull-left" caption="{}" data-is-target name="Name" margin="0em unset 0.5em unset" fontsize="1.143" fontunit="em"></wm-label>' +
        '<wm-label name="Time" data-is-target class="pull-right text-muted" caption="{}"></wm-label>' +
        '<wm-label caption="{}" data-is-target name="Description" class="p text-muted"></wm-label>' +
        '</wm-container>'
    }
  };


  constructor(override i18nService: I18nService, private typeFactory: TypeFactoryService, private pageTemplate: PageTemplatesService) {
    super();
    this.PageLayoutsService = inject(PageLayoutsService);
    this.variableService = inject(BaseVariableService);
    this.pageService = inject(PageService)
    this.appRef = inject(AppRef);
    this.pageWs = inject(PageWorkspaceComponent);
    this.pageWsService = inject(PageWsService);
    this.eventmanager = inject(EventManagerService);
    this.notificationService = inject(NotificationService);
    this.datatypes = this.typeFactory.getTypes()
    this.layouts = this.PageLayoutsService.getPageLayouts();
    this.isTemplateBundleType = this.projectService.isTemplateBundleType();
    this.isPrefabType = this.appRef.isPrefabType;
    this.isMobileApplicationType =this.projectService.isNativeMobileApplicationType()
    this.registerDestroyListener.add(runtimeEventManager.on('load-templatebundles').subscribe(() => {
      this.getPageTemplates();
    }));
    this.eventmanager.createpartialvariableObservable().subscribe((data)=>{
      if (data.type === 'TEMPLATE' && this.createdVariable.isNew === true) {
        this.saveVariable(data.name);
      }

    })
  }


  ngOnInit(): void {
   this.createdVariable = {};
    let newPageTypes;
    this.templateData =this.pageWs.templateData;

    if (this.isMobileApplicationType) {
      newPageTypes = [
        {type: 'page', label: 'LABEL_PAGE'},
        {type: 'partial', label: 'LABEL_PARTIAL'},
        {type: 'popover', label: 'LABEL_WIDGET_POPOVER'},
        {type: 'leftnav', label: 'LABEL_PROPERTY_LEFTNAV'},
        {type: 'template', label: 'LABEL_WIDGET_TEMPLATE'}
      ];
      // newPageTypes    = ['page', 'partial', 'popover', 'leftnav'];
    } else if (this.isPrefabType) {
      // only allow partial creation for prefab projects
      newPageTypes = [
        {type: 'partial', label: 'LABEL_PARTIAL'},
        {type: 'template', label: 'LABEL_WIDGET_TEMPLATE'}
      ];
    } else {
      newPageTypes = [
        {type: 'page', label: 'LABEL_PAGE'},
        {type: 'partial', label: 'LABEL_PARTIAL'},
        {type: 'popover', label: 'LABEL_WIDGET_POPOVER'},
        {type: 'header', label: 'LABEL_PROPERTY_HEADER'},
        {type: 'topnav', label: 'LABEL_PROPERTY_TOPNAV'},
        {type: 'template', label: 'LABEL_WIDGET_TEMPLATE'},
        {type: 'leftnav', label: 'LABEL_PROPERTY_LEFTNAV'},
        {type: 'rightnav', label: 'LABEL_PROPERTY_RIGHTNAV'},
        {type: 'footer', label: 'LABEL_PROPERTY_FOOTER'}
      ];
    }

    this.ctrlScope = this
    this.isWeb = true;
    this.isMobile = false;
    this.template = {
      'search': '',
      'category': '',
      'categories': [],
      'result': [],
      'selected': {}
    };

    this.getTemplates(this.isWeb)
    this.newPage = this.templateData && this.templateData.template === 'template' ? { /*variable for new page name*/
      type: 'template',
      name: '',
      label: 'LABEL_WIDGET_TEMPLATE'
    } : { /*variable for new page name*/
      type: newPageTypes[0].type,
      name: '',
      label: newPageTypes[0].label
    };
    this.newPageTypes = newPageTypes
    this.pageLayout = {activeLayout: this.isMobileApplicationType ? this.layouts[this.layouts.length - 1] : this.layouts[3]};
    this.loadingTemplates = false;
    this.templateCreated = false;
    this.baseScreen = 'newPageDlg';
    this.changeNewPageType(this.newPage, true);
    this.showTemplatePreview = false;

  }

  getTemplates(isWeb: boolean) {
    this.templatePlatformType = isWeb ? 'WEB' : 'MOBILE';
    this.isWeb = isWeb;
    this.isMobile = !isWeb;
    this.getPageTemplates();
    this.getTemplateCategories();
  }

  getPageTemplates() {
    this.loadingTemplates = true;
    this.pageTemplate.list(false, this.templatePlatformType)
      .then((response: any) => {
        this.loadingTemplates = false;
        this.allTemplates = [
          {
            'active': true,
            'bundleId': null,
            'id': '',
            'name': 'blank',
            'description': this.locale.LABEL_USE_BLANK_DESCRIPTION,
            'category': '',
            'keywords': 'blank',
            'published': true,
            'type': null,
            'thumbnail': '',
            'screenshots': []
          }
        ];

        this.template.selected = this.allTemplates[0];
        if (isArray(response)) {
          response.forEach((bundle) => {
            if (isArray(bundle.templates)) {
              bundle.templates.forEach((template: any) => {
                template.bundleId = bundle.id;
                template.bundleName = bundle.name;
                template.versionId = bundle.versionId;
                this.allTemplates.push(template);
              });
            }
          });
        }

        this.listTemplates = !this.isTemplateBundleType && this.allTemplates.filter((template: any) => {
          return template.type === 'template';
        });

        if (this.listTemplates.length && this.newPage.type === 'template' && this.templateData.template) {
          this.selectTemplate(this.listTemplates[0]);
        }
      }, () => {
        this.loadingTemplates = false;
      });
  }


  saveVariable (passedOwner:any) {
    let requiredVariableObject = this.createdVariable.variableObject;
    let owner = this.activePageName || passedOwner;
    /* Store the variable in proper category */
    this.variableService.store(owner, requiredVariableObject.name, requiredVariableObject, true, true);
    this.createdVariable.isNew = false;
    this.variableService.saveVariables(owner).then(()=> {
      this.onSaveSuccess();
    },  (errorMsg)=> {
      this.notificationService.show('error', "ERROR",errorMsg);
    });
  };
   onSaveSuccess () {
     this.eventmanager.emitUpdateVariableTree(this.createdVariable.variableObject);
  };




  selectTemplate = (template: any) => {
    if (this.template.selected) {
      this.template.selected.active = false;
    }
    this.template.selected = template;
    this.template.selected.active = true;
    this.preDefinedTemplateSelected = this.preDefinedTemplates[template.id] ? true : false;

    if (template.type === 'template' && this.preDefinedTemplateSelected) {
      this.listImage = 'styles/images/template/' + template.id + '/screenshot.png';
      processLiveWidgetTemplate(this.preDefinedTemplates[template.id].template, this);

    }
  };

  getTemplateCategories() {
    this.pageTemplate.getCategories()
      .then((response: any) => {
        let categories: any[] = [];
        if (isArray(response)) {
          categories = response.map((category: any) => {
            return {
              'key': category,
              'label': category
            };
          });
        }
        categories.unshift({'key': '', 'label': 'All'});
        this.template.categories = categories;
      });
  }


  changeNewPageType(pageType: any, isFirstTime?: any) {
    isFirstTime = isFirstTime || false;
    if (this.templateData && this.templateData.template === 'template' && !isFirstTime) {
      return;
    }
    if (this.stepCounter === 1 && pageType.type !== this.newPage.type) {
      this.stepCounter = this.stepCounter - 1;
    }
    this.newPage.type = pageType.type;
    this.newPage.label = pageType.label;
    if (!this.isTemplateBundleType) {
      this.templateType = 'previewAndName';
    } else {
      this.templateType = 'selectTemplateLayout';
    }
    if (this.newPage.type === 'template') {
      var options = {
        'owner': 'Page',
        '_serviceType': 'custom'
      };
      if (this.templateData && this.templateData.variableType) {
        const value = this.templateData.variableType.split('.');
        let service;
        if (value.length >= 3) {
          service = value[2];
        }
        this.typeFactory.getDataTypesByService(service, true).then(() => {
          this.createVariable('custom', options);
        })
      } else {
        this.createVariable('custom', options);
      }
    }
    this.resetTemplateSelection();
  };


  resetTemplateSelection() {
    forEach(this.allTemplates, (template) => {
      if (template.name === 'blank') {
        template.active = true;
        this.template.selected = template;
      } else {
        template.active = false;
      }
    });
    if (this.listTemplates.length && this.newPage.type === 'template' && !this.isTemplateBundleType) {
      this.selectTemplate(this.listTemplates[0]);
    }
  }

  createNewPage(dialogId: string): any {

    let pageName = this.newPage.name;
    this.pageWsService.templateWidgets = this.templateWidgets;
    this.pageWsService.createdVariable = this.createdVariable;
    this.pageWsService.template = this.template

    if (StudioUtils.validatePageName(this, pageName)) {
      if (this.template.selected.type === 'template' && this.createdVariable.variableObject && !this.createdVariable.variableObject.type )  {
        this.fileAddMessage = {'caption': this.locale.MESSAGE_WARN_ENTITY_EMPTY_DESC, type: 'error'};
        return false;
      }
      this.fileAddMessage = {'caption': this.locale.MESSAGE_CREATE_PAGE, type: 'loading'};

      $('[name=btn-create-page]').attr('disabled', "true");

      if (this.isTemplateBundleType) {
        this.createTemplate(this.onTemplateCreationSuccess.bind(undefined, pageName, dialogId, this), this.onPageCreationError.bind(this));
      } else {
        this.createPage(StudioUtils.onPageCreationSuccess.bind(undefined, pageName, dialogId, this,), this.onPageCreationError.bind(this));
      }
    }
  };

  onTemplateCreationSuccess(pageName: string, dialogId: any, $s: any, addNewWorkspace: any) {
    StudioUtils.onPageOrTemplateCreateSuccess($s, pageName);
    StudioUtils.updateTemplateConfig(ACTIONS.ADD, pageName, dialogId, $s);
  }

  onPageCreationError(errMsg: any) {
    this.fileAddMessage = {'caption': errMsg.message, type: 'error'};
    $('[name=btn-create-page]').removeAttr('disabled');
  }

  createTemplate(onSuccess: any, onError: any) {
    this.pageService.create({
      projectID: this.projectService.getProjectId(),
      pageName: this.newPage.name,
      pageType: this.newPage.type.toUpperCase(),
      templateName: this.template.selected.id,
      artifactId: this.template.selected.bundleId,
      versionId: this.template.selected.versionId
    }).then(onSuccess, onError)

  }

  createPage(onSuccess: any, onError: any) {
    this.pageService.create({
      projectID: this.projectService.getProjectId(),
      pageName: this.newPage.name,
      pageTitle: words(this.newPage.name).map(capitalize).join(' '),
      pageType: this.newPage.type.toUpperCase(),
      includedPageTypes: this.PageLayoutsService.getLayoutDetails(this.pageLayout.activeLayout.id),
      templateName: this.template.selected.id,
      artifactId: this.template.selected.bundleId,
      versionId: this.template.selected.versionId
    }).then(onSuccess, onError)
  }


  decrementStep() {
    if (this.newPage.type === 'page' && !this.isTemplateBundleType) {
      this.templateType = 'previewAndName';
    } else {
      this.templateType = 'selectTemplateLayout';
    }
    this.stepCounter = this.stepCounter - 1;
    this.baseScreen = 'newPageDlg';
    // Resetting template selection
    this.template['search'] = '';
    this.template['category'] = '';

  }

  incrementStep() {

    each(this.allTemplates, (temp) => {
      if (temp.type === 'widgettemplate' || temp.type === 'template') {
        remove(this.template.categories, {'key': temp.category});
      }
    });

    if (this.newPage.type === 'page' && !this.isTemplateBundleType) {
      if (StudioUtils.validatePageName(this, this.newPage.name)) {
        this.stepCounter = this.stepCounter + 1;
        this.templateType = 'selectTemplateLayout';
      }
    } else {
      this.stepCounter = this.stepCounter + 1;
      this.templateType = 'previewAndName';
      if (this.newPage.type === 'template') {
        this.baseScreen = 'templateContext';
        var options = {
          'owner': 'Page',
          '_serviceType': 'custom'
        };
if( this.templateData && this.templateData.variableType){
  const value = this.templateData.variableType.split('.');
  let service;
  if (value.length >= 3) {
    service = value[2];
  }
  this.typeFactory.getDataTypesByService(service,true).then(()=>{
    this.createVariable('custom', options);
  })
}else {
  this.createVariable('custom', options);
}


      }
    }

  }

  createVariable(category: string, options: any) {

    let variableCategory = 'wm.Variable';

    if (!this.createdVariable.variableObject) {
      /* call base service function to create the variable */
      this.createdVariable.variableObject = this.variableService.createVariable(variableCategory, options, 'item');
      this.createdVariable.variableObject.category = variableCategory;
      this.createdVariable.variableObject.type = '';

      this.getExternalTypes();

      // Showing the bound entity of selected widget when opens it from toolbar template icon
      if (this.templateData && this.templateData.variableType) {
        this.createdVariable.variableObject.type = this.templateData.variableType;
        this.onVariablePropertyChange({
          propertyName: 'type', value: {
            'name': StudioUtils.getUpdatedPropertyName(this.templateData.variableType, true),
            'value': this.templateData.variableType
          }
        });
        this.createdVariable.propertyObj.type.disabled = true;
        this.createdVariable.propertyObj.type.selectedOption = this.createdVariable.propertyObj.type.options.find((option: any) => option.value === this.createdVariable.propertyObj.type.modelObj.type);
        this.selectedDataSource =  this.createdVariable.propertyObj.type.selectedOption.displayType
      }
    }
  }

  getServiceEntitie($event: any) {
    this.service = $event.name

    this.typeFactory.getDataTypesByService(this.service, true).then((res) => {

      if (this.newPage.type === 'template') {
        var options = {
          'owner': 'Page',
          '_serviceType': 'custom'
        };
        this.createdVariable = {};
        if ($event.name === 'FileService') {
          this.service = 'fileservice';
        }

        this.createVariable('custom', options);
      }
    })

  }

  clearServiceEntitie() {
    this.createdVariable.propertyObj['type'].selectedOption = null;
  }

  getExternalTypes() {
    externalTypes = [];
    this.createdVariable.isNew = true;
    this.createdVariable.propertyObj = {};
    this.createdVariable.propertyObj.type = {};
    this.createdVariable.propertyObj.type.options = [];
    this.createdVariable.propertyObj.type.propertyName = 'name';
    this.createdVariable.propertyObj.type.modelPropertyName = 'value';
    this.createdVariable.propertyObj.type.modelObj = this.createdVariable.variableObject;
    this.createdVariable.propertyObj.type.modelKey = 'type';
   let projectDetails = this.projectService.getDetails();
    console.log(projectDetails);
    // Append Service types
    forEach(this.typeFactory.dataTypes, (typeObj, typeLabel) => {
      if (isString(typeObj.service) && stringStartsWith(typeLabel, this.service ? projectDetails.properties.packagePrefix+'.'+ this.service : 'com.') && !stringStartsWith(typeLabel, 'com.wavemaker.')) {
        externalTypes.push(typeLabel);
      }
    });

      externalTypes = uniq(externalTypes.sort());
    forEach(externalTypes, (val) => {
      this.createdVariable.propertyObj.type.options.push({
        'name': StudioUtils.getUpdatedPropertyName(val, true),
        'value': val,
        'displayType': this.typeFactory.dataTypes[val].service
      });
    });
  };

  setWidgetProp(prop: any) {
    var fieldName = StudioUtils.getFieldName(prop);
    prop.value = 'bind:Variables.' + this.createdVariable.variableObject.name + '.dataSet' + fieldName;
    this.selectedWidget.hasBinding = true;
  };

  onVariablePropertyChange($event: any) {
    this.createdVariable.variableObject.type =  $event.value.value;
    let variable = this.createdVariable.variableObject;
    let newDataBindings = [];
    variable.dataSet = StudioUtils.getTypeModel($event.value.value);
    variable.name = $event.value.name?.split('(')[0] + 'Item';
    newDataBindings.push({
      target: 'dataBinding',
      value: 'bind:pageParams.item'
    });
    variable.dataBinding = newDataBindings;
    this.fileAddMessage = '';
    this.fields = StudioUtils.getFieldObjectsForData(this.createdVariable.variableObject.dataSet);

  };

  onClose(): void {
    this.handleClose.emit();
  }

  previewTemplate($event: any) {
    $event.event.stopPropagation();
    this.template.preview = $event.template;
    this.showTemplatePreview = true;
  };

  selectTemplateWidget(widget: any) {
    this.selectedWidget = widget;
  };

  override ngOnDestroy() {
    super.ngOnDestroy();
    if (!this.templateCreated) {
      this.createdVariable = {};
    }
    this.pageWs.templateData = {};
  }

  importTemplateBundle(evt: any) {

  }

}
